const adjustStickyHeaderTop = () => {
  const selluxeAnnouncementBar = document.querySelector('#shopify-section-sections--23596758663512__selluxe_announcement_slider_rjNQ7i');
  const header = document.querySelector('#SiteHeader'); // Fixed typo

  console.log('scrolling');

  if (!selluxeAnnouncementBar || !header) return; // Use `||` instead of `&&` for proper validation

  if (header.classList.contains('site-header--opening')) {
    header.style.top = `${selluxeAnnouncementBar.offsetHeight}px`;
  } else {
    header.style.top = `0`;
  }
};

// Correctly call the function on scroll
window.addEventListener('scroll', adjustStickyHeaderTop);
